import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { formatNumber } from "../../../utils/DefaultFunction";

export default function ChannelSavingsChart({ data }) {
  const chartHeight = 500;
 

  function prepareChartData(data) {
    const categories = data?.map(item => item.channel_name);
    const domesticData = data?.map(item => item.domestic.messages);
    const internationalData = data?.map(item => item.international.messages);
    const totalData = data?.map(item => item.total_messages);
    return { categories, domesticData, internationalData, totalData };
  }

  const { categories, domesticData, internationalData, totalData } = prepareChartData(data);

  const options = {
    chart: {
      type: "column",
      height: chartHeight,
      backgroundColor: "transparent",
      style: {
        fontFamily: "Inter, sans-serif",
      },
    },
    legend: { enabled: true },
    title: {
      text: null,
      align: "left",
      style: {
        fontSize: "18px",
        fontWeight: "bold",
        color: "#1f2937",
      },
    },
    xAxis: {
      categories: categories,
      title: { text: null },
      labels: {
        style: { fontSize: "12px" },
      },
    },
    yAxis: {
      min: 0,
      title: { text: null },
      labels: {
        overflow: "justify",
      },
      gridLineWidth: 1,
    },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        let s = `<b>${this.x}</b><br/>`;
        this.points.forEach((point) => {
          s += `
            <div style="margin:4px 0;">
              <span style="color:${point.series.color}">${point.series.name}:</span> 
              <b style="color:${point.series.color}">${formatNumber(point.y)}</b>
            </div>`;
        });
        return s;
      },
    },
    plotOptions: {
      column: {
        borderRadius: 2,
        pointPadding: 0.1,
        groupPadding: 0.2,
      },
    },
    credits: { enabled: false },
    series: [
      {
        name: "Domestic Messages",
        data: domesticData,
        color: "#10b981", // green
      },
      {
        name: "International Messages",
        data: internationalData,
        color: "#3b82f6", // blue
      },
    //   {
    //     name: "Total Messages",
    //     data: totalData,
    //     color: "#f59e0b", // orange
    //   },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
